import React from "react"
import { InputWithLabel, FormRow } from "./common"

const Password = ({
  dirty,
  edit,
  password,
  passwordConfirm,
  onChangeInput,
  onBlur,
  onFocus,
}) => (
  <FormRow isEditing={dirty} last>
    <InputWithLabel
      isEditing={dirty}
      edit={edit}
      label="Password"
      showError={password.edited && !password.valid && !password.isActive}
      error={password.error}
      onFocus={onFocus("password")}
      onBlur={onBlur("password")}
      onChange={onChangeInput("password")}
      value={password.value}
      fieldType="password"
      required
    />
    <InputWithLabel
      isEditing={dirty}
      maxLength="256"
      edit={edit}
      label="Confirm Password"
      error={passwordConfirm.error}
      showError={
        passwordConfirm.edited &&
        !passwordConfirm.valid &&
        !passwordConfirm.isActive
      }
      onFocus={onFocus("passwordConfirm")}
      onBlur={onBlur("passwordConfirm")}
      onChange={onChangeInput("passwordConfirm")}
      value={passwordConfirm.value}
      fieldType="password"
      required
    />
  </FormRow>
)

export { Password as default }



// WEBPACK FOOTER //
// ./assets/account/components/forms/Password.js